import * as React from 'react';
import {
  // Button, Col, Form, FormGroup, Label, 
  Modal,
  // Row 
} from 'reactstrap';
import { IUser } from 'src/model';
import { Svg } from '../Svg';


interface ICVModalProps {
  isOpen: boolean;
  toggleCVModal: () => void;
  consultant : IUser;
}

export const CVModal: React.SFC<ICVModalProps> = ({
  consultant,
  isOpen,
  toggleCVModal,
}) => {
  return (
    <Modal size='lg' className='position-relative' isOpen={isOpen}>
      <Svg
        className='position-absolute'
        fill='primary'
        width={280}
        height={210}
        opacity={0.1}
        src='bulle-popin'
        style={{ top: '-19px', left: '-15px' }}
      />
      <div className='d-flex justify-content-end p-3'>
        <Svg
          fill='dark'
          src='close'
          width={16}
          onClick={toggleCVModal}
        />
      </div>
      <div className='mt-3'   >
        ceci est le cv de : 
              {consultant &&
                `${consultant.firstname} ${consultant.lastname} ${consultant.address.city} ${consultant.profile.title}
                `}
            </div>
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Modals/CVModal.tsx